var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Compiler, Component, ElementRef, Input, ViewChild, ViewContainerRef, } from '@angular/core';
import { ControlModel, FormType, getOptionalProperty, getRequiredProperty, } from '@synisys/idm-dynamic-layout-interpreter';
import { TooltipSettings } from '@synisys/idm-ng-controls';
import { Set } from 'immutable';
import { assign, forIn, includes, isBoolean, isEmpty, isNil, isNumber, join, size, split, values, } from 'lodash';
import * as Mustache from 'mustache';
import { takeUntil } from 'rxjs/operators';
import { ControlActionCallGenerator } from '../../service/layout-actions';
import { AbstractDestructionSubject } from '../abstract-destruction-subject';
import { DynamicLayout } from '../dynamic-layout';
import { getContextEntity, getDisplayFieldsNames, isBooleanString, isControlApplicableToFields, } from '../utilities';
import './control.component.scss';
var ControlComponent = /** @class */ (function (_super) {
    __extends(ControlComponent, _super);
    function ControlComponent(compiler) {
        var _this = _super.call(this) || this;
        _this.compiler = compiler;
        _this.isTitleExists = false;
        _this._isReady = false;
        _this.actionCallGenerator = new ControlActionCallGenerator();
        return _this;
    }
    ControlComponent_1 = ControlComponent;
    Object.defineProperty(ControlComponent.prototype, "tooltipSettings", {
        get: function () {
            return this._tooltipSettings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlComponent.prototype, "styleBlock", {
        get: function () {
            return this._styleBlock;
        },
        set: function (value) {
            this._styleBlock = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlComponent.prototype, "container", {
        set: function (containerRef) {
            this._container = containerRef;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlComponent.prototype, "controlModel", {
        get: function () {
            return this._controlModel;
        },
        set: function (controlModel) {
            this._controlModel = controlModel;
            this.fieldSet = values(controlModel.fields);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    ControlComponent.makeBackwardCompatible = function (controlTemplate) {
        // this is done for aot
        var backwardCompatibleTemplate = controlTemplate.replace(/(.+)\[id]\s*=\s*['"]%{id}['"](.+)/gm, '$1 [id]="\'%{id}\'" $2');
        return backwardCompatibleTemplate;
    };
    ControlComponent.prototype.ngOnInit = function () {
        this.processControl();
        this.checkForTitle();
    };
    ControlComponent.prototype.ngDoCheck = function () {
        this.processData();
    };
    ControlComponent.prototype.ngAfterViewChecked = function () {
        if (this.label) {
            if (this.label.nativeElement.offsetWidth) {
                this.tooltipLeftPosition =
                    this.label.nativeElement.offsetWidth + 2;
            }
        }
    };
    ControlComponent.prototype.ngOnDestroy = function () {
        if (this.componentReference) {
            this.componentReference.destroy();
        }
        if (this._container) {
            this._container.remove();
        }
        _super.prototype.ngOnDestroy.call(this);
    };
    ControlComponent.prototype.getRequiredClassIfNeeded = function () {
        if (this.isRequired() &&
            this.layout.isForm() &&
            this.layout.getMetaForm().formType === FormType.EDIT) {
            return ' sis-form__label--required';
        }
        else {
            return '';
        }
    };
    ControlComponent.prototype.getValidationMessage = function () {
        if (this.layout.isForm()) {
            if (this.isValidationExists()) {
                for (var _i = 0, _a = this.layout.getValidations(); _i < _a.length; _i++) {
                    var validation = _a[_i];
                    if (isControlApplicableToFields(validation.getRelatedMetaFieldIds(), this.fieldSet, getDisplayFieldsNames(validation))) {
                        return validation
                            .getMessage()
                            .getValue(this.layout.getCurrentLanguage().getId());
                    }
                }
            }
            else {
                throw new Error(this._controlModel.selector + " doesn't have fields so has no validation message");
            }
        }
        return '';
    };
    ControlComponent.prototype.isValidationExists = function () {
        return size(this._controlModel.fields) === 1;
    };
    ControlComponent.prototype.isWithTooltip = function () {
        return this.tooltipSettings && this.tooltipSettings.isWithTooltip;
    };
    ControlComponent.prototype.isPartlyHidden = function () {
        return (this.label &&
            this.text &&
            this.label.nativeElement.offsetWidth <
                this.text.nativeElement.offsetWidth);
    };
    ControlComponent.prototype.loadSummary = function (summary) {
        if (summary !== undefined &&
            !ControlComponent_1.loadedSummaries.has(summary)) {
            ControlComponent_1.loadedSummaries = ControlComponent_1.loadedSummaries.add(summary);
            this.compiler['loadAotSummaries'](function () { return [summary]; });
        }
    };
    ControlComponent.prototype.processControl = function () {
        var _this = this;
        this.processData();
        if (this._controlModel.selector) {
            var moduleKeys = this.layout.getMetaForm()
                ? this.layout.getMetaForm().layoutModel.moduleKeys
                : undefined;
            this.layout
                .getModuleRegistryService()
                .findModuleAndControlType(this._controlModel.selector, moduleKeys)
                .pipe(takeUntil(this.destroySubject$))
                .subscribe(function (_a) {
                var moduleType = _a.moduleType, summary = _a.summary;
                if (!isNil(summary)) {
                    summary.forEach(function (s) { return _this.loadSummary(s); });
                }
                _this.layout.addRuntimeComponent(_this._controlModel, moduleType, _this.componentDecoratorScheme(_this._controlModel.metaControl.template, []), _this.cellTitle, _this.tabId);
            }, console.error);
            this.layout.readyToDrawComponents
                .pipe(takeUntil(this.destroySubject$))
                .subscribe(function () {
                _this._container.clear();
                if (_this.componentReference) {
                    _this.componentReference.destroy();
                }
                var cmpFactory = _this.layout.getRuntimeComponentFactory(_this._controlModel.id);
                _this.componentReference = _this._container.createComponent(cmpFactory, undefined, _this.layout.getRuntimeModuleRef().injector, undefined, _this.layout.getRuntimeModuleRef());
            }, console.error);
        }
        this.initTooltip();
    };
    ControlComponent.prototype.checkForTitle = function () {
        if (isNil(this.cellTitle)) {
            this.isTitleExists = false;
        }
        else if (!isNil(this.cellTitle.messageId)) {
            this.isTitleExists = true;
        }
        else if (!isNil(this.cellTitle.customText)) {
            var titleNotEmpty_1 = false;
            forIn(this.cellTitle.customText, function (value) {
                if (!isNil(value) && value !== '') {
                    titleNotEmpty_1 = true;
                }
            });
            this.isTitleExists = titleNotEmpty_1;
        }
    };
    ControlComponent.prototype.processData = function () {
        this.currentLanguageId = this.layout.getCurrentLanguage().getId();
    };
    ControlComponent.prototype.componentDecoratorScheme = function (controlTemplate, providers) {
        var mappings = this.resolveMappings();
        controlTemplate = ControlComponent_1.makeBackwardCompatible(controlTemplate);
        Mustache.parse(controlTemplate, ['%{', '}']);
        var template = Mustache.render(controlTemplate, mappings);
        return {
            template: template,
        };
    };
    ControlComponent.prototype.resolveMappings = function () {
        var resultMap = {};
        if (this._controlModel) {
            resultMap = assign(resultMap, this.obtainControlFieldsMap(), this.obtainActionCalls(), this._controlModel.bindings, this.obtainControlProperties());
        }
        return resultMap;
    };
    ControlComponent.prototype.obtainActionCalls = function () {
        var actionsCallObject = {};
        if (!isEmpty(this._controlModel.actions)) {
            var controlComponent_1 = this;
            forIn(this._controlModel.actions, function (actionName, actionKey) {
                actionsCallObject[actionKey] = controlComponent_1.processActionCall(actionName);
            });
        }
        return actionsCallObject;
    };
    ControlComponent.prototype.processActionCall = function (controlActionValue) {
        var _this = this;
        var funcCalls = [];
        split(controlActionValue, ';').forEach(function (actionName) {
            if (_this.layout.isForm()) {
                if (includes(actionName, '-async')) {
                    var realActionName_1 = split(actionName, '-', 1)[0];
                    var aptLayoutAction = _this.layout
                        .getLayoutActions()
                        .find(function (action) { return action.name === realActionName_1; });
                    funcCalls.push(_this.actionCallGenerator.generateCall(_this.controlModel, aptLayoutAction, true, getContextEntity(_this.layout), _this.getParentField));
                }
                else {
                    var aptLayoutAction = _this.layout
                        .getLayoutActions()
                        .find(function (action) { return action.name === actionName; });
                    funcCalls.push(_this.actionCallGenerator.generateCall(_this.controlModel, aptLayoutAction, aptLayoutAction.isAsync, getContextEntity(_this.layout), _this.getParentField));
                }
            }
        });
        return join(funcCalls, ';');
    };
    ControlComponent.prototype.obtainControlFieldsMap = function () {
        var _this = this;
        var fieldsObject = {};
        var contextEntity = getContextEntity(this.layout);
        forIn(this._controlModel.fields, function (fieldValue, key) {
            if (fieldValue) {
                fieldsObject[key] = contextEntity + ".getProperty('" + getOptionalProperty(fieldValue, 'metaFieldId.systemName') + "').value";
                fieldsObject[key + '-name'] = getRequiredProperty(fieldValue, 'metaFieldId.systemName');
                fieldsObject[key + '-category'] = getOptionalProperty(fieldValue, 'compoundCategorySystemName');
                fieldsObject[key + '-id'] = contextEntity + ".getProperty('" + getOptionalProperty(fieldValue, 'metaFieldId.systemName') + "').value === null ? null : " + contextEntity + ".getProperty('" + getRequiredProperty(fieldValue, 'metaFieldId.systemName') + "').value.getId()";
                var parentField = _this.getParentField(fieldValue);
                if (!isNil(parentField)) {
                    fieldsObject[key + '-parent'] = contextEntity + ".getProperty('" + getOptionalProperty(parentField, 'metaFieldId.systemName') + "').value";
                    fieldsObject[key + '-parent-category'] = getOptionalProperty(parentField, 'compoundCategorySystemName');
                    fieldsObject[key + '-parent-id'] = contextEntity + ".getProperty('" + getOptionalProperty(parentField, 'metaFieldId.systemName') + "').value === null ? null : " + contextEntity + ".getProperty('" + getRequiredProperty(parentField, 'metaFieldId.systemName') + "').value.getId()";
                }
            }
        });
        return fieldsObject;
    };
    ControlComponent.prototype.getParentField = function (childField) {
        var childClassifiers = this.layout.getMetaForm().childClassifiers;
        if (!isNil(childClassifiers)) {
            return childClassifiers.find(function (childClassifier) {
                return childClassifier.child.getMetaFieldId().getSystemName() ===
                    "{" + getRequiredProperty(childField, 'metaFieldId.systemName');
            });
        }
    };
    ControlComponent.prototype.obtainControlProperties = function () {
        var propObject = {};
        if (this._controlModel.properties &&
            this._controlModel.properties.generalProperties) {
            this._controlModel.properties.generalProperties.forEach(function (propValue, key) {
                if (!isNumber(propValue) &&
                    !isBoolean(propValue) &&
                    !isBooleanString(propValue)) {
                    propObject[key] = JSON.stringify(propValue);
                }
                else if (isBooleanString(propValue)) {
                    propObject[key] = propValue === 'true';
                }
                else {
                    propObject[key] = propValue;
                }
            });
            propObject['disabled'] = this._controlModel.properties.generalProperties.get('disabled', false);
            propObject['id'] = this._controlModel.properties.generatedId;
        }
        return propObject;
    };
    ControlComponent.prototype.isRequired = function () {
        if (this.layout.isForm()) {
            return isControlApplicableToFields(this.layout.getMetaForm().requiredMetaFieldIds, this.fieldSet);
        }
        else {
            return false;
        }
    };
    ControlComponent.prototype.initTooltip = function () {
        if (this._controlModel.properties &&
            this._controlModel.properties.generalProperties.has('tooltipSettings')) {
            var json = this._controlModel.properties.generalProperties.get('tooltipSettings');
            this._tooltipSettings = TooltipSettings.fromJsonString(json);
            if (this._tooltipSettings.isWithTooltip) {
                this._tooltipSettings.isWithTooltip = !(isNil(this._tooltipSettings.caption) &&
                    isNil(this._tooltipSettings.content));
            }
        }
    };
    ControlComponent.loadedSummaries = Set();
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], ControlComponent.prototype, "styleBlock", null);
    __decorate([
        ViewChild('container', { read: ViewContainerRef }),
        __metadata("design:type", ViewContainerRef),
        __metadata("design:paramtypes", [ViewContainerRef])
    ], ControlComponent.prototype, "container", null);
    __decorate([
        Input(),
        __metadata("design:type", ControlModel),
        __metadata("design:paramtypes", [ControlModel])
    ], ControlComponent.prototype, "controlModel", null);
    __decorate([
        Input(),
        __metadata("design:type", DynamicLayout)
    ], ControlComponent.prototype, "layout", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ControlComponent.prototype, "cellTitle", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], ControlComponent.prototype, "tabId", void 0);
    __decorate([
        ViewChild('label'),
        __metadata("design:type", ElementRef)
    ], ControlComponent.prototype, "label", void 0);
    __decorate([
        ViewChild('text'),
        __metadata("design:type", ElementRef)
    ], ControlComponent.prototype, "text", void 0);
    ControlComponent = ControlComponent_1 = __decorate([
        Component({
            moduleId: module.id + '',
            selector: 'control',
            template: require('./control.component.html'),
        }),
        __metadata("design:paramtypes", [Compiler])
    ], ControlComponent);
    return ControlComponent;
    var ControlComponent_1;
}(AbstractDestructionSubject));
export { ControlComponent };
//# sourceMappingURL=control.component.js.map